import { MEDIA_QUERIES } from "@src/constants/media-queries";
import { useMediaQuery } from "@uhg-abyss/web/hooks/useMediaQuery";
import { styled } from "@uhg-abyss/web/tools/styled";
import { Heading } from "@uhg-abyss/web/ui/Heading";
import type { FC } from "react";

const SectionGrid = styled("ul", {
  display: "grid",
  gap: "0 20px",
  paddingLeft: "10px",
  textAlign: "left",
  variants: {
    isMobile: {
      true: { gridTemplateColumns: "1fr", fontSize: "16px" },
      false: { gridTemplateColumns: "1fr 1fr" },
    },
    isTablet: {
      true: { fontSize: "16px" },
      false: { fontSize: "18px" },
    },
  },
});

const SectionItem = styled("li", {
  display: "grid",
  gridTemplateColumns: "auto 1fr",
  gap: "8px",
});

interface SectionListProps {
  title: string;
  items: string[];
  showHeading?: boolean;
}

export const SectionList: FC<SectionListProps> = ({ title, items, showHeading = true }) => {
  const isMobile = useMediaQuery(MEDIA_QUERIES.mobileMax);
  const isTablet = useMediaQuery(MEDIA_QUERIES.tabletMax);

  // Sort items by length (shortest to longest)
  const sortedItems = items.sort((a, b) => {
    return a.length - b.length;
  });
  return (
    <div>
      {showHeading && (
        <Heading
          size="sm"
          css={{
            textAlign: "left",
            marginBottom: "16px",
            lineHeight: isMobile ? "24px" : "28px",
          }}
        >
          {title}
        </Heading>
      )}
      <SectionGrid isMobile={isMobile} isTablet={isTablet}>
        {sortedItems.map((item) => {
          return (
            <SectionItem key={item}>
              <span>•</span>
              <span>{item}</span>
            </SectionItem>
          );
        })}
      </SectionGrid>
    </div>
  );
};
